<template>
  <v-dialog v-model="data.open" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t(data.title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <formComponent
            ref="formComponent"
            :form="operatingInstructionForm"
            v-model="operatingInstructionForm.formData"
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey" outlined @click="closeform">{{
          $t("general.back")
        }}</v-btn>
        <v-btn color="primary" @click="saveForm(false)" data-cy="saveEvent">
          {{ $t("operatingInstructions.upload") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
function getDefaultData() {
  return {
    tag: "",
    color: "",
    files: [],
    instructionCategory: "",
    labels: [],
    labelId: null,
  };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../components/api/api";
export default {
  components: { formComponent },
  props: ["data"],
  data: () => ({
    operatingInstructionForm: {
      formData: getDefaultData(),
      form: [
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "py-0 mt-6",
            id: getUniqueId(),
            componentName: "operatingInstructionUpload",
            config: { multiple: true },
          },
        ],
      ],
    },
  }),
  methods: {
    closeform() {
      this.data.open = false;
      this.resetData();
    },
    async saveForm(createNew) {
      // attach the category from the route
      this.operatingInstructionForm.formData.instructionCategory =
        this.$route.params.instructionCategoryId;

      // validate form (Vuetify returns true when valid)
      if (!this.$refs.formComponent.validateAllFields()) return;

      // get files and category from formData
      const { files, instructionCategory, tag, color, labelId } =
        this.operatingInstructionForm.formData;

      if (!Array.isArray(files) || files.length === 0) {
        this.$store.commit("CREATE_SNACKBAR", this.$t("general.fieldRequired"));
        return;
      }

      let finalLabelId = labelId || null;

      if (!finalLabelId && color && tag) {
        const res = await this.$store.dispatch(
          "createOperatingInstructionLabel",
          {
            tag,
            color,
          }
        );
        finalLabelId = res._id;
      }

      this.$root.$emit("operatingInstructionLabelsUpdated");

      try {
        const payloads = files.map((f) => ({
          name: f.name,
          filetype: f.filetype,
          content: f.content,
          instructionCategory,
          operatingInstructionLabel: finalLabelId,
        }));

        await Promise.all(
          payloads.map((p) =>
            this.$store.dispatch("createOperatingInstruction", p)
          )
        );

        if (createNew) {
          this.resetData();
        } else {
          this.closeform();
          this.resetData();
        }
      } catch (e) {
        console.error("Upload failed:", e);
        // optional: show a toast/snackbar
      }
    },
    resetData() {
      this.operatingInstructionForm.formData = getDefaultData();
      this.$refs.formComponent.resetForm();
      this.reloadData();
      // consider removing this to avoid a full page reload:
      // location.reload();
    },
    reloadData() {
      this.$emit("reloadData");
    },
  },
};
</script>
